<template>
    <b-modal :id="modalId" title="Nova Tarefa" size="lg" centered scrollable
        @hidden="resetForm">
        <b-form>
            <b-row>
                <b-col md="8">
                    <b-form-group label="Motivo de acionamento *">
                        <b-form-select v-model="form.reason" :state="errors.reason ? false : null">
                            <option :value="null" disabled>-- Selecione --</option>
                            <option v-for="r in reasonsList.filter(r => r.active)" :key="r._id" :value="r.name">
                                {{ r.name }}
                            </option>
                        </b-form-select>
                        <b-form-invalid-feedback>{{ errors.reason }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>

                <b-col md="4">
                    <b-form-group label="Canal *">
                        <b-form-select v-model="form.channel" :state="errors.channel ? false : null">
                            <option :value="null" disabled>-- Selecione --</option>
                            <option value="whatsapp">Whatsapp</option>
                            <option value="telefone">Telefone</option>
                            <option value="email">E-mail</option>
                        </b-form-select>
                        <b-form-invalid-feedback>{{ errors.channel }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-form-group label="Janela" v-if="filterByReason()">
                <b-form-input v-model="form.janela" placeholder="Janela de atendimento" />
            </b-form-group>

            <b-row>
                <b-col md="6">
                    <b-form-group label="Cliente">
                        <b-form-input v-model="form.client_name" placeholder="Cliente" maxlength="100" />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Endereço">
                        <b-form-input v-model="form.address" placeholder="Endereço" maxlength="100" />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="4">
                    <b-form-group label="Tipo de Serviço">
                        <b-form-select v-model="form.service_type">
                            <option :value="null">-- Selecione --</option>
                            <option value="Abastecimento">Abastecimento</option>
                            <option value="Recolhimento">Recolhimento</option>
                            <option value="Suprimento">Suprimento</option>
                        </b-form-select>
                    </b-form-group>
                </b-col>

                <b-col md="4"  v-if="form.service_type === 'Recolhimento'">
                    <b-form-group label="Horário do Malote">
                        <b-form-input type="time" v-model="form.service_date" />
                    </b-form-group>
                </b-col>

                <b-col md="4">
                    <b-form-group label="Cliente Itaú">
                        <div class="custom-control custom-switch mt-1">
                            <input v-model="form.is_itau" type="checkbox" class="custom-control-input" id="form_is_itau" />
                            <label class="custom-control-label" for="form_is_itau">
                                {{ form.is_itau ? 'SIM' : 'NÃO' }}
                            </label>
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-form-group label="Descrição">
                <b-form-textarea v-model="form.description" rows="3" placeholder="Descreva a tarefa..." />
            </b-form-group>

            <b-row>
                <b-col md="6">
                    <b-form-group label="Código da Tarefa *">
                        <b-form-input v-model="form.protocol" disabled :state="errors.protocol ? false : null" />
                        <b-form-invalid-feedback>{{ errors.protocol }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group label="Protocolo do Atendimento">
                        <b-form-input v-model="form.ref_protocol" placeholder="ex: 260122143142" />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6">
                    <b-form-group label="Prioridade *">
                        <b-form-select v-model="form.priority_id" :disabled="priorityLockedByChannel"
                            :state="errors.priority_id ? false : null">
                            <option :value="null" disabled>-- Selecione --</option>
                            <option v-for="p in prioritiesList" :key="p._id" :value="p._id">
                                {{ `${p.name} (${convertSecondsToTime(p.time)})` }}
                            </option>
                        </b-form-select>
                        <b-form-invalid-feedback>{{ errors.priority_id }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group label="Status *">
                        <b-form-select v-model="form.status_id" :state="errors.status_id ? false : null">
                            <option :value="null" disabled>-- Selecione --</option>
                            <option v-for="s in statusesList.filter(s => !s.is_finisher)" :key="s._id" :value="s._id">
                                {{ s.name }}
                            </option>
                        </b-form-select>
                        <b-form-invalid-feedback>{{ errors.status_id }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6">
                    <b-form-group label="Base (Grupo) *">
                        <b-form-select v-model="form.group_id" @change="onGroupChange"
                            :state="errors.group_id ? false : null">
                            <option :value="null" disabled>-- Selecione --</option>
                            <option v-for="g in groupsList" :key="g._id" :value="g._id">
                                {{ g.name }}
                            </option>
                        </b-form-select>
                        <b-form-invalid-feedback>{{ errors.group_id }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group label="Responsável">
                        <b-form-select v-model="form.user_id">
                            <option :value="null">-- Selecione --</option>
                            <option v-for="u in filteredUsers" :key="u._id" :value="u._id">
                                {{ u.name }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-form-group label="Anexos" class="mt-2">
                <div class="task-attach-btn" @click="addAttach">
                    <i class="fas fa-paperclip"></i> Anexar arquivos
                </div>
                <div v-if="attachments.length > 0" class="task-attach-list">
                    <div v-for="(file, index) in attachments" :key="index" class="task-attach-item">
                        <span class="task-attach-info">
                            <i :class="getFileIcon(file.name)"></i>
                            {{ file.name }}
                            <small class="text-muted">({{ formatFileSize(file.size) }})</small>
                        </span>
                        <button type="button" class="task-attach-remove" @click="removeAttach(index)"
                            title="Remover">✕</button>
                    </div>
                </div>
            </b-form-group>
        </b-form>

        <template #modal-footer>
            <b-button variant="secondary" @click="$bvModal.hide(modalId)">Cancelar</b-button>
            <b-button variant="primary" :disabled="saving" @click="save">
                <b-spinner v-if="saving" small class="mr-1" />
                Criar
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import { convertSecondsToTime } from '../../helpers/utils';
import { taskManagerAxios } from './connections/taskApiConnection';

export default {
    name: 'TaskFormModal',
    props: {
        modalId: { type: String, default: 'task-form-modal' },
        prioritiesList: { type: Array, default: () => [] },
        statusesList: { type: Array, default: () => [] },
        groupsList: { type: Array, default: () => [] },
        usersList: { type: Array, default: () => [] },
        reasonsList: { type: Array, default: () => [] },
    },
    data() {
        return {
            saving: false,
            errors: {},
            ticketId: null,
            form: this.emptyForm(),
            attachments: [],
        };
    },
    computed: {
        priorityLockedByChannel() {
            return this.form.channel === 'whatsapp' || this.form.channel === 'telefone';
        },
        filteredUsers() {
            if (!this.form.group_id) return [];
            const group = this.groupsList.find(g => g._id === this.form.group_id);
            if (!group?.members?.length) return [];
            return this.usersList.filter(u => group.members.some(m => (typeof m === 'object' ? m.id : m) == u._id));
        },
    },
    watch: {
        'form.channel'(channel) {
            if (channel === 'whatsapp' || channel === 'telefone') {
                const alta = this.prioritiesList.find(p => p.name.toLowerCase().includes('alta'));
                this.form.priority_id = alta?._id ?? null;
            } else if (channel === 'email') {
                const baixa = this.prioritiesList.find(p => p.name.toLowerCase().includes('baixa'));
                this.form.priority_id = baixa?._id ?? null;
            }
        },
    },
    methods: {
        convertSecondsToTime,
        open(defaults = null) {
            this.resetForm();
            const pendente = this.statusesList.find(s => s.name.toLowerCase() === 'pendente');
            if (pendente) this.form.status_id = pendente._id;
            if (defaults) {
                if (defaults?.ticket_id) this.ticketId = defaults.ticket_id;
                Object.assign(this.form, defaults);
            }
            this.$bvModal.show(this.modalId);
        },
        onGroupChange() {
            this.form.user_id = null;
        },
        async save() {
            this.errors = {};
            if (!this.form.reason) this.errors.reason = 'O motivo de acionamento é obrigatório.';
            if (!this.form.channel) this.errors.channel = 'O canal é obrigatório.';
            if (!this.form.protocol?.trim()) this.errors.protocol = 'O protocolo é obrigatório.';
            if (!this.form.priority_id) this.errors.priority_id = 'A prioridade é obrigatória.';
            if (!this.form.status_id) this.errors.status_id = 'O status é obrigatório.';
            if (!this.form.group_id) this.errors.group_id = 'O grupo é obrigatório.';
            if (Object.keys(this.errors).length) return;

            this.saving = true;
            try {
                const payload = await this.buildPayload();
                const { data } = await taskManagerAxios.post('/tasks', payload);

                this.$emit('saved', data);
                data.ticket_id = this.ticketId;
                this.$emit('task-created', data);
                this.$bvModal.hide(this.modalId);
                Swal.fire({
                    icon: 'success',
                    title: 'Tarefa criada com sucesso 😊',
                    toast: true,
                    timer: 2000,
                    showConfirmButton: false
                });
            } catch (error) {
                console.error(error)
                this.$emit('saved', false);
                this.$emit('task-created', false);
                const msg = error.response?.data?.message ?? 'Erro ao salvar tarefa.';
                const errs = error.response?.data?.errors ?? {};
                if (Object.keys(errs).length) {
                    this.errors = Object.fromEntries(Object.entries(errs).map(([k, v]) => [k, v[0]]));
                } else {
                    Swal.fire({ icon: 'error', title: 'Erro', text: msg });
                }
            } finally {
                this.saving = false;
            }
        },
        async buildPayload() {
            const priority = this.prioritiesList.find(p => p._id === this.form.priority_id) ?? null;
            const status = this.statusesList.find(s => s._id === this.form.status_id) ?? null;
            const group = this.groupsList.find(g => g._id === this.form.group_id) ?? null;
            const user_obj = this.usersList.find(u => u._id === this.form.user_id) ?? null;
            const attachments = await Promise.all(this.attachments.map(f => this.fileToBase64(f)));
            const serviceDate = this.form.service_date ? `${new Date().toISOString().slice(0, 10)}T${this.form.service_date}` : null;
            const crtUser = user.getIdPrefix() && user.getName ?
                {
                    _id: user.getIdPrefix(),
                    name: user.getName()
                } : null;

            return {
                description: this.form.description || null,
                client_name: this.form.client_name || null,
                address: this.form.address || null,
                protocol: this.form.protocol || null,
                ref_protocol: this.form.ref_protocol || null,
                channel: this.form.channel || null,
                reason: this.form.reason || null,
                janela: this.filterByReason() ? (this.form.janela || null) : null,
                is_itau: this.form.is_itau ?? false,
                service_date: serviceDate,
                service_type: this.form.service_type || null,
                sla: priority?.time ?? null,
                priority: priority ? { _id: priority._id, name: priority.name, color: priority.color, time: priority.time, percent_alert: priority.percent_alert, level: priority.level } : null,
                status: status ? { _id: status._id, name: status.name, color: status.color, is_finisher: status.is_finisher } : null,
                owner_group: group ? { _id: group._id, name: group.name, members: group.members } : null,
                owner_user: user_obj ? { _id: user_obj._id, name: user_obj.name } : null,
                attachments,
                user: crtUser
            };
        },
        filterByReason() {
            if (!this.form?.reason) return false;
            const valideReason = this.form?.reason?.toLowerCase();
            return ['previsão de atendimento', 'antecipação'].includes(valideReason);
        },
        fileToBase64(file) {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve({
                    filename: file.name,
                    content: e.target.result.split(',')[1],
                });
                reader.readAsDataURL(file);
            });
        },
        resetForm() {
            this.errors = {};
            this.ticketId = null;
            this.form = this.emptyForm();
            this.attachments = [];
        },
        generateProtocol() {
            const digits = '0123456789';
            const alphanumeric = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            const rand = (chars) => chars[Math.floor(Math.random() * chars.length)];
            const numeric = Array.from({ length: 2 }, () => rand(digits)).join('');
            const rest = Array.from({ length: 8 }, () => rand(alphanumeric)).join('');
            return `TF${numeric}${rest}`;
        },
        emptyForm() {
            return {
                description: '',
                client_name: '',
                address: '',
                protocol: this.generateProtocol(),
                ref_protocol: '',
                channel: null,
                sla: null,
                priority_id: null,
                status_id: null,
                group_id: null,
                user_id: null,
                reason: null,
                janela: null,
                is_itau: false,
                service_date: null,
                service_type: null,
            };
        },
        addAttach() {
            if (this.attachments.length >= 10) {
                Swal.fire({ title: 'Limite atingido', text: 'Máximo de 10 arquivos por tarefa.', icon: 'warning', confirmButtonText: 'OK' });
                return;
            }
            const input = document.createElement('input');
            input.type = 'file';
            input.multiple = true;
            input.onchange = (e) => {
                const files = Array.from(e.target.files);
                const remaining = 10 - this.attachments.length;
                if (files.length > remaining) {
                    Swal.fire({ title: 'Limite atingido', text: `Apenas ${remaining} arquivo(s) serão adicionados (máximo 10).`, icon: 'warning', confirmButtonText: 'OK' });
                    this.attachments = [...this.attachments, ...files.slice(0, remaining)];
                } else {
                    this.attachments = [...this.attachments, ...files];
                }
            };
            input.click();
        },
        removeAttach(index) {
            this.attachments.splice(index, 1);
        },
        getFileIcon(fileName) {
            const ext = fileName.split('.').pop().toLowerCase();
            const map = {
                jpg: 'fas fa-file-image', jpeg: 'fas fa-file-image', png: 'fas fa-file-image',
                gif: 'fas fa-file-image', bmp: 'fas fa-file-image', svg: 'fas fa-file-image',
                pdf: 'fas fa-file-pdf',
                doc: 'fas fa-file-word', docx: 'fas fa-file-word',
                xls: 'fas fa-file-excel', xlsx: 'fas fa-file-excel',
                ppt: 'fas fa-file-powerpoint', pptx: 'fas fa-file-powerpoint',
                txt: 'fas fa-file-alt',
                mp3: 'fas fa-file-audio', wav: 'fas fa-file-audio', ogg: 'fas fa-file-audio',
                mp4: 'fas fa-file-video', avi: 'fas fa-file-video', mov: 'fas fa-file-video',
                zip: 'fas fa-file-archive', rar: 'fas fa-file-archive', '7z': 'fas fa-file-archive',
                html: 'fas fa-file-code', css: 'fas fa-file-code', js: 'fas fa-file-code',
                json: 'fas fa-file-code', php: 'fas fa-file-code',
            };
            return map[ext] ?? 'fas fa-file-alt';
        },
        formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        },
    },
}
</script>

<style scoped>
.task-attach-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 14px;
    border: 1px dashed #1c869a;
    border-radius: 6px !important;
    color: #1c869a;
    cursor: pointer;
    font-size: 13px;
    transition: background 0.15s;
    user-select: none;
}

.task-attach-btn:hover {
    background: #f0f9fb;
}

.task-attach-list {
    margin-top: 10px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
}

.task-attach-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 10px;
    border: 1px solid #ddd;
    border-radius: 6px !important;
    background: #fafafa;
    font-size: 13px;
}

.task-attach-info {
    display: flex;
    align-items: center;
    gap: 6px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.task-attach-remove {
    background: none;
    border: none;
    color: #dc3545;
    cursor: pointer;
    font-size: 13px;
    padding: 0 4px;
    line-height: 1;
    flex-shrink: 0;
}

.task-attach-remove:hover {
    color: #a71d2a;
}

input,
select,
textarea,
button {
    border-radius: 5px !important;
}
</style>
